import { explainCarrierError } from '@/utils/carrierErrorText';

/**
 * A carrier refusal in a cell or a note: the English line on top when the refusal is a known one, and the carrier's own
 * words under it, so the desk can still copy them to YunExpress support (SSD-7512).
 */
export function CarrierErrorText({ message }: { message: string }) {
  const english = explainCarrierError(message);
  if (!english) {
    return <>{message}</>;
  }
  return (
    <>
      <span className="d-block">{english}</span>
      <span className="d-block text-muted" lang="zh">
        {message}
      </span>
    </>
  );
}
